export const PERMISSION_ORGANISATION_LIST = 'organisation.list';
export const PERMISSION_LICENCE_BULK_CREATE = 'licence.bulk-create';
export const PERMISSION_LICENCE_CREATE = 'licence.create';

export type Permission = typeof PERMISSION_ORGANISATION_LIST |
    typeof PERMISSION_LICENCE_BULK_CREATE |
    typeof PERMISSION_LICENCE_CREATE;